// dev_lp — "What is CARTAX?" section: intro + two feature cards.
import React from "react";
import { useTranslation } from "react-i18next";
import CheckIcon from "../components/CheckIcon";
import SectionHeading from "../components/SectionHeading";

const WhatIsSection: React.FC = () => {
  const { t } = useTranslation();

  const card1 = [t("whatIs.card1Line1"), t("whatIs.card1Line2")];
  const card2 = [t("whatIs.card2Line1"), t("whatIs.card2Line2")];

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 mb-20">
      <SectionHeading className="mb-6">{t("whatIs.title")}</SectionHeading>
      <p className="text-center text-base md:text-lg text-gray-700 mb-10 max-w-3xl mx-auto leading-relaxed">
        {t("whatIs.intro")}
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {[card1, card2].map((lines, idx) => (
          <div
            key={idx}
            className="bg-white/80 backdrop-blur rounded-3xl p-7 shadow-xl shadow-blue-900/5 ring-1 ring-white/60 hover:shadow-2xl hover:-translate-y-1 transition-all"
          >
            <ul className="space-y-5">
              {lines.map((line, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckIcon className="mt-0.5" />
                  <span className="text-gray-800 leading-relaxed">{line}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatIsSection;
